import { render, staticRenderFns } from "./PassRequestController.vue?vue&type=template&id=15c0a0d4&scoped=true"
import script from "./PassRequestController.vue?vue&type=script&lang=ts"
export * from "./PassRequestController.vue?vue&type=script&lang=ts"
import style0 from "./PassRequestController.vue?vue&type=style&index=0&id=15c0a0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c0a0d4",
  null
  
)

export default component.exports